// extracted by mini-css-extract-plugin
export default {"notInLiveModeContainer":"notInLiveModeContainer--hB9nT","notInLiveModePopover":"notInLiveModePopover--mAR57"};